/**
 * MessageBubble — a single transcript entry.
 *
 * User messages sit on the trailing side (Spark-accent fill),
 * Coach messages on the leading side (neutral surface + avatar).
 * "Leading" and "trailing" here are logical — under RTL the
 * Coach bubble renders on the right, user on the left, because
 * of `self-start` / `self-end` which are bidi-aware.
 */

import type { CoachMessage } from './store';
import { Avatar } from './Avatar';
import { cn } from '@/utils/cn';

export function MessageBubble({ message }: { message: CoachMessage }) {
  const isUser = message.author === 'user';

  return (
    <li
      role="group"
      aria-label={isUser ? 'You said' : 'Coach said'}
      className={cn(
        'flex w-full gap-2',
        isUser ? 'justify-end' : 'justify-start',
      )}
    >
      {!isUser ? <Avatar /> : null}
      <div
        className={cn(
          'max-w-[78%] rounded-2xl px-4 py-2 text-sm leading-relaxed',
          isUser
            ? 'bg-spark text-white'
            : 'border border-border bg-surface text-ink',
        )}
      >
        <p className="whitespace-pre-line">{message.body}</p>
      </div>
    </li>
  );
}
